import { oneLineTrim } from 'common-tags';
import {
    includeParam,
} from 'app/react/state/middleware/api'

const root = (eventId, artistTypeId) =>
    `events/${eventId}/artist-types/${artistTypeId}/production-website/artists/settings`;

export const fetchOne = (
    eventId,
    artistTypeId,
    includes = []
) => oneLineTrim`
    ${root(eventId, artistTypeId)}?
    ${includeParam(includes)}&
`;

export const updateOne = (
    eventId,
    artistTypeId,
    includes = []
) => oneLineTrim`
    ${root(eventId, artistTypeId)}?
    ${includeParam(includes)}
`;
